import React, { Fragment, memo, useCallback } from 'react'
import tw from 'twin.macro'
import { useSelector } from 'react-redux'
import { useYardstik } from 'src/hooks/useYardstik'
import { InfoContainer } from '../shared/InfoContainer'
import { MVRCollectDataStep } from 'src/interfaces/collectData'
import { getCurrentCollectDataStep } from 'src/selectors/collectData'

const MVRProceedWithYardstikComponent = () => {
  const currentStep = useSelector(getCurrentCollectDataStep) as MVRCollectDataStep

  const { startYardstik, YardstikView } = useYardstik()

  const showYardstik = useCallback(() => {
    startYardstik(currentStep.id)
  }, [currentStep.id])

  return (
    <Fragment>
      <InfoContainer
        className={tw`mt-4`}
        actionText="Tap to proceed with Yardstik"
        onClick={showYardstik}
        dataTestId="contractors-onboarding-mvr-manual-yardstik-info-btn"
      >
        If you don't have a current Motor Vehicle Record Background Check Report, you can use
        Yardstik to run one.
      </InfoContainer>
      <YardstikView />
    </Fragment>
  )
}

export const MVRProceedWithYardstik = memo(MVRProceedWithYardstikComponent)
